export default "__VITE_ASSET__b77ba343__"